import { staffClient } from 'clients/staff';
import { getS3UploadUrl, uploadS3File } from 'utils/s3';

export interface Award {
    id: number;
    award_name: string;
    issuing_organization: string;
    award_number?: string;
    award_date: string;
    photo_url?: string;
    is_visible: boolean;
    created_at: string;
    updated_at: string;
}

export interface AwardListResponse {
    data: Award[];
    total: number;
    offset: number;
    limit: number;
}

export interface CreateAwardDto {
    award_name: string;
    issuing_organization: string;
    award_number?: string;
    award_date: string;
    photo_url?: string;
}

export interface UpdateAwardDto {
    award_name?: string;
    issuing_organization?: string;
    award_number?: string;
    award_date?: string;
    photo_url?: string;
    is_visible?: boolean;
}

export const awardApi = {
    // Get all awards with pagination and search
    getAwards: async (params?: {
        offset?: number;
        limit?: number;
        searchText?: string;
    }) => {
        return await staffClient.get<AwardListResponse>('/award', { params });
    },

    // Get single award by ID
    getAward: async (id: number) => {
        return await staffClient.get<Award>(`/award/${id}`);
    },

    // Create new award
    createAward: async (data: CreateAwardDto) => {
        return await staffClient.post<Award>('/award', data);
    },

    // Update award
    updateAward: async (id: number, data: UpdateAwardDto) => {
        return await staffClient.patch<Award>(`/award/${id}`, data);
    },

    // Delete award
    deleteAward: async (id: number) => {
        return await staffClient.delete(`/award/${id}`);
    },

    // Upload award photo using S3
    uploadPhoto: async (file: File) => {
        try {
            // Get S3 upload URL
            const uploadUrl = await getS3UploadUrl(file);
            if (!uploadUrl) {
                throw new Error('Failed to get upload URL');
            }
            
            // Upload file to S3
            const imageUrl = await uploadS3File(file, uploadUrl);
            if (!imageUrl) {
                throw new Error('Failed to upload file');
            }
            
            return imageUrl;
        } catch (error) {
            console.error('Failed to upload award photo:', error);
            throw error;
        }
    }
};